import { action } from 'satcheljs';

export interface ResetNumDaysInDayRangeActionMessage {
    isUserChange: boolean;
}
export const resetNumDaysInDayRange: (
    isUserChange?: boolean
) => ResetNumDaysInDayRangeActionMessage = action(
    'resetNumDaysInDayRange',
    (isUserChange: boolean = true): ResetNumDaysInDayRangeActionMessage => ({
        isUserChange,
    })
);
